<template>
  <el-dialog
    :visible.sync="innerReturnDialog"
    :title="`退货方案`"
    :before-close="closeDialog"
    width="800px"
  >
    <div v-if="isStockUp">
      <div>
        <h4 style="margin:0;padding-bottom: 20px;">产品信息</h4>
        <info-table
          :field-arr="productField"
          :table-data="[curData]"
        ></info-table>
        <h4>修改方案</h4>
        <el-table
          :header-cell-style="tableHeader"
          border
          :data="tablePlainData"
        >
          <el-table-column
            prop="plain"
            label="方案"
          ></el-table-column>
          <el-table-column label="数量">
            <template v-slot="{ row }">
              <el-input-number
                v-model="row.count"
                :controls="false"
                @change="changeProCount(row)"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="罚没单价">
            <template v-slot="{ row }">
              <el-input-number
                v-model="row.sforfeitureProice"
                :controls="false"
                :min="0"
                @change="changeProforfeitureProice(row)"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="罚没比例">
            <template v-slot="{ row }">
              <el-input-number
                style="margin-right: 3px;"
                v-model="row.sforfeiturePenalty"
                :controls="false"
                :min="0"
                @change="changeProforfeiturePenalty(row)"
              ></el-input-number>
              %
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div v-else>
      <el-table
        border
        :header-cell-style="tableHeader"
        :data="[curData]"
      >
        <el-table-column
          label="品牌"
          prop="brandName"
        ></el-table-column>
        <el-table-column
          label="型号"
          prop="proType"
        ></el-table-column>
        <el-table-column
          label="订货号"
          prop="orderNumber"
        ></el-table-column>
        <el-table-column
          label="销售单价"
          prop="cbPrice"
        ></el-table-column>
        <el-table-column
          label="数量"
          prop="count"
        ></el-table-column>
        <el-table-column
          label="退货方案"
          prop="returnPlain"
        ></el-table-column>
        <el-table-column
          label="罚没单价"
          prop=""
        >
          <template v-slot="{ row }">
            <el-input-number
              style="width:100%;"
              :controls="false"
              :min="0"
              v-model="row.sforfeitureProice"
              @change="changeStopstockUpPrice"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column
          label="罚没比例"
          prop=""
        >
          <template v-slot="{ row }">
           <div style="white-space: nowrap">
             <el-input-number
               style="width:93%;"
               :controls="false"
               :min="0"
               v-model="row.sforfeiturePenalty"
               @change="changeStopstockUpBill"
             ></el-input-number>  %
           </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="dialog-footerex">
      <slot name="footer">
        <el-button type="primary" @click="submitData">确 定</el-button>
        <el-button @click="closeDialog">取 消</el-button>
      </slot>
    </div>
  </el-dialog>
</template>

<script>
import InfoTable from '@/components/module/infoTable'
import { deliverStateex, invoiceStateex, stockupTypeStatusex } from '@/meun/date'
import NP from 'number-precision'
import { deepClone } from '@/util'

export default {
  name: 'checkReturnDialog',
  components: { InfoTable },
  props: ['returnDialog', 'isStockUp', 'rowData', 'rowDataex'],
  data () {
    return {
      innerReturnDialog: false,
      curData: {},
      tablePlainData: [
        {
          plain: '退至供应商'
        },
        { plain: '退至仓库' }
      ],
      productField: [
        {
          label: '品牌',
          name: 'brandName'
        },
        {
          name: 'proType',
          label: '型号'
        },
        {
          name: 'orderNumber',
          label: '订货号'
        },
        {
          name: 'cbPrice',
          label: '销售单价'
        },
        {
          name: 'stockupState',
          label: '备货状态',
          formatter(val) {
            return stockupTypeStatusex[val] || '--'
          }
        },
        {
          name: 'deliverState',
          label: '发货状态',
          formatter(val) {
            return deliverStateex[val] || '--'
          }
        },
        {
          name: 'invoiceState',
          label: '开票状态',
          formatter(val) {
            return invoiceStateex[val] || '--'
          }
        },
        {
          name: 'returnPlain',
          label: '退货方案'
        },
        {
          name: 'count',
          label: '数量'
        }
      ]
    }
  },
  watch: {
    innerReturnDialog (newVal) {
      this.$emit('update:returnDialog', newVal)
      return newVal
    },
    returnDialog (newVal) {
      this.innerReturnDialog = newVal
    },
    rowData(newVal = {}) {
      if (Array.isArray(newVal)) return {}
      this.curData = Object.assign(newVal, {
        sforfeiturePenalty: NP.strip(newVal.forfeiturePenalty * 100) || 0,
        sforfeitureProice: NP.strip(newVal.forfeitureProice) || 0
      })
      return newVal
    }
  },
  methods: {
    changeProforfeiturePenalty (row) {
      const { curData, tablePlainData } = this
      const { cbPrice } = curData
      const index = this.findCurIndex(row, true)
      if (index !== -1) {
        const { sforfeiturePenalty } = row
        tablePlainData[index].sforfeitureProice = NP.strip(cbPrice * sforfeiturePenalty / 100)
      }
      this.tablePlainData = deepClone(tablePlainData)
    },
    changeProforfeitureProice (row) {
      const { curData, tablePlainData } = this
      const { cbPrice } = curData
      const index = this.findCurIndex(row, true)
      if (index !== -1) {
        const { sforfeitureProice } = row
        tablePlainData[index].sforfeiturePenalty = NP.strip((sforfeitureProice / cbPrice) * 100).toFixed(3)
      }
      this.tablePlainData = deepClone(tablePlainData)
    },
    changeProCount (row) {
      if (row.count < 0) {
        this.$message.error('请设置正确的退货数量')
        row.count = 0
        return
      }
      const { curData, tablePlainData } = this
      const index = this.findCurIndex(row, false)
      if (row.count > curData.count) {
        this.$message.error('退货数量不可超过退货方案产品数量')
        row.count = ''
        return
      }
      if (index !== -1 && (row.count <= curData.count)) {
        tablePlainData[index].count = curData.count - row.count
      }
      this.tablePlainData = deepClone(tablePlainData)
    },
    /**
     * @author: wf
     * @createdate: 2021-01-20 14:06
     * @mark: 寻找退到供应商还是仓库 false寻找另外一个 true寻找当前修改
     */
    findCurIndex(row, flag) {
      const { tablePlainData } = this
      let index = 0
      if (flag) {
        index = tablePlainData.findIndex(item => item.plain === row.plain)
      } else {
        index = tablePlainData.findIndex(item => item.plain !== row.plain)
      }
      return index
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    /**
     * @author: wf
     * @createdate: 2021-01-20 13:39
     * @mark: 未备货改变金额计算比例
     */
    changeStopstockUpPrice () {
      const { curData } = this
      const { sforfeitureProice, cbPrice } = curData
      Object.assign(curData, {
        sforfeiturePenalty: NP.strip((sforfeitureProice / cbPrice) * 100).toFixed(2)
      })
      this.curData = deepClone(curData)
    },
    /**
     * @author: wf
     * @createdate: 2021-01-20 13:39
     * @mark: 未备货改变比例计算金额
     */
    changeStopstockUpBill () {
      const { curData } = this
      const { sforfeiturePenalty, cbPrice } = curData
      Object.assign(curData, {
        sforfeitureProice: NP.strip(cbPrice * (sforfeiturePenalty / 100)).toFixed(3)
      })
      this.curData = deepClone(curData)
    },
    closeDialog () {
      this.curData = {}
      this.tablePlainData = [
        {
          plain: '退至供应商'
        },
        { plain: '退至仓库' }
      ]
      this.$emit('update:returnDialog', false)
    },
    submitData () {
      const { curData, isStockUp, tablePlainData } = this
      if (!isStockUp) {
        /**
         * @author: wf
         * @createdate: 2021-01-20 11:50
         * @mark: 未备货产品提交
         */
        this.$emit('update:rowDataex', Object.assign(curData, {
          forfeitureProice: curData.sforfeitureProice || 0,
          forfeiturePenalty: NP.strip(curData.sforfeiturePenalty / 100) || 0
        }))
      } else {
        /**
         * @author: wf
         * @createdate: 2021-01-20 11:50
         * @mark: 已备货产品提交
         */
        let count = 0
        tablePlainData.forEach(item => {
          count += (item.count || 0)
        })
        if (curData.count !== count) {
          this.$message.error('设置退货方案数量不等于产品退货数量')
          return
        }
        this.$emit('update:rowDataex', tablePlainData.map(item => {
          return Object.assign(deepClone(curData), {
            ...item,
            count: item.count,
            returnPlain: item.plain,
            forfeitureProice: item.sforfeitureProice || 0,
            forfeiturePenalty: NP.strip(item.sforfeiturePenalty / 100) || 0
          })
        }).filter(item => item.count))
      }
      this.closeDialog()
    }
  }
}
</script>

<style
  scoped
  lang="less"
>
  /deep/ .el-dialog__title {
    line-height: 20px;
    padding-left: 20px;
  }

  /deep/ .dialog-footerex {
    text-align: right;
    margin-top: 20px;
  }
</style>
